module.exports = __webpack_public_path__ + "static/splatky1-839d6f7cb349d1ec0c4adb9d77363738.jpg";